
export const STUDIOS = {
    DATA: 'data_studio',
    ML: 'ml_pipelines',
    WORKFLOW: 'workflow_studio',
    ALL: 'all' // Admin view
};

export const STUDIO_NODE_CATEGORIES = {
    [STUDIOS.DATA]: [
        "Sources",
        "Preparation",
        "Transformation",
        "Output",
        "Utility" // Common
    ],
    [STUDIOS.ML]: [
        "AI/ML",
        "Insights",
        "Preparation", // Often needed for ML
        "Sources", // Needed to get data
        "Output",
        "Utility"
    ],
    [STUDIOS.WORKFLOW]: [
        "Triggers",
        "Actions",
        "Automation Workflow",
        "Utility",
        "Logic", // Split, etc.
        "Sources", // Sometimes needed
        "Output"
    ],
    [STUDIOS.ALL]: [] // All
};

export const STUDIO_LABELS = {
    [STUDIOS.DATA]: "Data Studio",
    [STUDIOS.ML]: "ML Studio",
    [STUDIOS.WORKFLOW]: "Workflow Studio",
    [STUDIOS.ALL]: "Flow Studio"
};

export const STUDIO_DESCRIPTIONS = {
    [STUDIOS.DATA]: "Design ETL pipelines to extract, transform, and load data.",
    [STUDIOS.ML]: "Build and deploy machine learning models and AI agents.",
    [STUDIOS.WORKFLOW]: "Automate business processes and integrate applications.",
    [STUDIOS.ALL]: "Design, orchestrate, and monitor all types of workflows."
};
